import {useMediaQuery, useTheme} from "@mui/material";
import { MobileDatePicker, DesktopDatePicker } from "@mui/x-date-pickers";
import TextField from "./TextField";

const DatePicker = ({label, value, onChange, name, ...props}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), {
    noSsr: true
  });

  const convertToDefEventPara = (name, value) => ({
        target: {
            name, value
        }
    })

  const TextFieldSlot = (params) => <TextField name={name} {...params} {...props} />;

  return (
    isMobile ? (
      <MobileDatePicker
        label={label}
        value={value}
        onChange={(date) => onChange(convertToDefEventPara(name, date))}
        slots={{ textField: TextFieldSlot }}
        slotProps={{ textField: { name, ...props } }}
        {...props}
      />
    ) : (
      <DesktopDatePicker
        label={label}
        value={value}
        onChange={(date) => onChange(convertToDefEventPara(name, date))}
        slots={{ textField: TextFieldSlot }}
        slotProps={{ textField: { name, ...props } }}
        {...props}
      />
    )
  )
}

export default DatePicker